import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import { Button } from "react-migration/components/DeprecatedButton";

import { Footer } from "../components/Footer";
import { DownloadLetter } from "./components/DownloadLetter";

export const DownloadLetterStep = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="letters-download-letter-step" className="flex flex-col w-full h-full">
      <DownloadLetter />

      <Footer percentage={100}>
        <div className="flex justify-end invisible grow">
          <Button.Primary disabled>{t("sites.letters.back_to_site")}</Button.Primary>
        </div>
      </Footer>
    </div>
  );
};
